import { TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import React, { useEffect, useState } from "react";
import adminService from "../../Services/adminService";
import { Button } from "@material-ui/core";
import Swal from "sweetalert2";
import ReactTooltip from "react-tooltip";

const CONSTANTS = [
  { name: "Btax", src: "https://practicum-classes.s3.eu-central-1.amazonaws.com/logo-btax.png" },
  { name: "Practicum", src: "https://practicum-classes.s3.eu-central-1.amazonaws.com/logo-practicum.png" },
  {
    name: "Assessor",
    src: "https://practicum-classes.s3.eu-central-1.amazonaws.com/logo-assessor.png"
  }
];

const AdminCourseVideos = (props) => {
  const [allEpisodes, setAllEpisodes] = useState([]);

  const courseTitles = props.courses.map((course) => course.title);

  useEffect(() => {
    if (props.editMode) {
      handleCourse(props.courseTitle);
    }
  }, []);

  return (
    <div className="flex flex-direction-column items-center height500">
      <ReactTooltip place="top" type="light" backgroundColor="transparent" effect="solid" border borderColor="#0d8eff" />
      <h3 className="mt-30 mb-50">פרקים</h3>
      <Autocomplete
        style={{ marginTop: "10px", width: "550px" }}
        options={courseTitles}
        getOptionLabel={(option) => option}
        onChange={(e, val) => handleCourse(val)}
        renderInput={(params) => <TextField {...params} label="שם קורס" />}
      />
      <div className="flex justify-evenly width85 mt-20 flex-wrap nice-scroller-episodes align-flex-start">
        {allEpisodes.map((episode, index) => {
          return (
            <div key={index} className="flex flex-direction-column bordered mt-32 center width-45">
              <div className="flex justify-around mt-10">
                {episode.logos &&
                  episode.logos.map((logo) => {
                    return (
                      <div key={logo}>
                        <img style={{ height: "30px" }} alt="course logo" src={CONSTANTS.find((constant) => constant.name === logo).src} />
                      </div>
                    );
                  })}
              </div>
              <div className="fs-25" data-tip={episode.title}>
                {episode.title.length > 15 ? episode.title.substring(0, 15) + "..." : episode.title}
              </div>
              <div
                className="pointer"
                onClick={() => navigator.clipboard.writeText(`http://www.bquick.co.il/video-watching/${episode._id}`)}
              >
                {episode.link.length > 30 ? episode.link.substring(0, 30) + "..." : episode.link}
              </div>
              <div className="flex justify-between mt-30">
                <Button
                  color="primary"
                  variant="contained"
                  onClick={() => {
                    props.setVideoDetails({
                      id: episode._id,
                      title: episode.title,
                      course: props.courses.find((course) => course._id === episode.belongToCourseId).title,
                      logos: episode.logos,
                      link: episode.link,
                      isActive: episode.isActive,
                      validUntilDate: episode.validUntilDate
                    });
                    props.setValue(0);
                    props.setEditMode(true);
                  }}
                >
                  לערוך
                </Button>
                <Button
                  color="secondary"
                  variant="contained"
                  onClick={() => {
                    deleteEpisode(episode._id, index);
                  }}
                >
                  למחוק
                </Button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );

  async function handleCourse(val) {
    if (val === null) return setAllEpisodes([]);
    try {
      const courseId = props.courses.find((course) => course.title === val)._id;
      const res = await adminService.getCourseVideos(courseId);
      if (res.success) {
        setAllEpisodes(res.courseVideos);
      }
    } catch (err) {
      console.log(err);
    }
  }

  async function deleteEpisode(id, index) {
    try {
      Swal.fire({
        title: "האם אתה בטוח שאתה רוצה למחוק את הפרק?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "כן",
        cancelButtonText: "לא",
        closeOnConfirm: false,
        closeOnCancel: false
      }).then(async (result) => {
        if (result.value === true) {
          const res = await adminService.deleteEpisode(id);
          if (res.success) {
            Swal.fire("הפרק נמחק בהצלחה", "", "success");
            let newSelectedList = [...allEpisodes];
            newSelectedList.splice(index, 1);
            setAllEpisodes(newSelectedList);
          } else {
            Swal.fire("שגיאה במחיקת פרק", "", "error");
          }
        }
      });
    } catch (err) {
      console.log(err);
    }
  }
};

export default AdminCourseVideos;
